module.exports = "<div id=\"mb-cc\"\n     class=\"mb\"\n     content-container>\n\t<div ng-transclude\n\t     class=\"mb-cc-content\"\n\t\t ng-class=\"{'without-env-bar':$root.isEnvBarHidden}\">\n\t</div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/base/components/content-container/content-container.template.html
// module id = 206
// module chunks = 0